const Izin = resolve => {
    require.ensure(['../views/apps/izin/Izin'], () => {
        resolve(require('../views/apps/izin/Izin.vue'));
    });
};
const IzinTanimla = resolve => {
    require.ensure(['../views/apps/izin/IzinTanimla'], () => {
        resolve(require('../views/apps/izin/IzinTanimla'));
    });
};
const IzinListesi = resolve => {
    require.ensure(['../views/apps/izin/IzinListesi'], () => {
        resolve(require('../views/apps/izin/IzinListesi'));
    });
};
const IzinGuncelle = resolve => {
    require.ensure(['../views/apps/izin/IzinGuncelle'], () => {
        resolve(require('../views/apps/izin/IzinGuncelle'));
    });
};

import layouts from '../layout';
import Vue from 'vue';

Vue.component('izintanimla', IzinTanimla);
Vue.component('izinlistesi', IzinListesi);
Vue.component('izinguncelle', IzinGuncelle);

export default {
    path: '/izin',
    name: 'izin',
    component: Izin,
    meta: {
        layout: layouts.navLeft,
    },
};
